

import { makeStyles } from '@material-ui/core/styles';

export const useCustomStyles = makeStyles(() => ({
	input: {
		height: '36px',
		'& input': {
			padding: "8px 12px",
		},
		'& .MuiOutlinedInput-input': {
			padding: "8px 12px",
		},
		'&.MuiOutlinedInput-adornedEnd': {
			paddingRight: "10px",
		},
		'& .MuiSelect-icon': {
			top: "calc(50% - 9px)",
		}
	},
	numberInput: {
		height: '36px',
		minHeight: '36px',
		'& input': {
			padding: "0 4px 0 8px",
		},
		'& .MuiOutlinedInput-input': {
			padding: "0 4px 0 8px",
		},
		'&.MuiOutlinedInput-adornedEnd': {
			paddingRight: "10px",
		},
	},
	multipleLinesInput: {
		minHeight: '36px',
		padding: "0",
		'& textarea': {
			padding: "8px 12px",
		},
	},
}));